/* eslint-disable import/prefer-default-export */
import axios from 'axios';

const { additionalHeaders, loginRootUrl } = window.appAirDrop.config;

export async function postAddHomeCountry(data: AddHomeCountry) {
  const path = `${loginRootUrl}/login/applyHomeCountryCode`;
  const response = await axios.post(
    path,
    data,
    {
      headers: {
        ...(additionalHeaders ?? {}),
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    },
  );

  return response;
}
